import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { CustomerShareIndicadorPipeModule } from '../pipes';

import { CustomerShareIndicadorBadgeComponent } from './customer-share-indicador-badge.component';


@NgModule({
    imports: [
        SharedModule,
        CustomerShareIndicadorPipeModule
    ],
    declarations: [
        CustomerShareIndicadorBadgeComponent
    ],
    exports: [
        CustomerShareIndicadorBadgeComponent
    ]
})
export class CustomerShareIndicadorBadgeModule { }
